/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Ported Minicart Style Logic - Elements are dynamically named/generated
let headerWrapper = $("div.Header__Wrapper")[0];
let headerFlexItemFill = headerWrapper.children[2];
let hdrSecondaryNavHiddenPhone = headerFlexItemFill.children[0];
let horizontalList = hdrSecondaryNavHiddenPhone.children[0];
let hiSearch = horizontalList.children[0];
let horizontalItem = horizontalList.children[2];
let hiHeading = horizontalItem.children[0];
let hspan = hiHeading.children[0];
let miniCart = horizontalItem.children[1];
let miniCartItWrapper = miniCart.children[1];

//alert(hspan);

//console.log(horizontalItem);

horizontalItem.addEventListener('mouseover', function() {
  //console.log("mini-cart entry-point");
  let miniCart = $("div.mini-cart")[0];
  //console.log(miniCart);
  miniCart.style.display = "block";
});

horizontalItem.addEventListener('mouseout', function() {
  //console.log("mini-cart exit-point");
  let miniCart = $("div.mini-cart")[0];
  miniCart.style.display = "none";
});

// very direct port from devst-js.js.liquid

let addToCart = $("button.ProductForm__AddToCart");
addToCart.click(function () {
  addToCartImpl();
  onSideCartReady();
});

function onRemoveClicked() {
  var $id = $(this).parent();
  var $this = $(this);
  var b = $id.data('variant');
  $this.parent('.mini-cart-item').css('opacity', '.5');
  console.log("mini-cart variant: " + b);
  
  $.ajax({ 
    url:'/cart/change.js', 
    data: { id: b, quantity: 0 },
    complete: function() {
      console.log("in");
      Shopify.getCart(function(cart) {
        let totalPrice = Shopify.formatMoney(cart.total_price, Theme.moneyFormat);
        //console.log('devst_remove_item - ' + cart.total_price);
        //console.log(cart);
        $(hspan).html(cart.item_count);

        $('.devst_subtotal').html('Total: ' + totalPrice);
        $this.parent('.mini-cart-item').remove();
      });
    }
  });
}

$('.devst_remove_item').click(onRemoveClicked);

// ProductItem styling for collection page

let counter = 0;

$(document).ready(function () {
  //let piImg = $("img.ProductItem__Image");
  //console.log("ProductItem__Image count(2) " + piImg.length);
  
  var $carousel = $('div.ProductList');
  //console.log("carousel " + $carousel.length);
  //console.log($carousel[0]);
  
  $carousel.on("ready.flickity", function() {
    //let piImg = $("img.ProductItem__Image");
  	//console.log("in flickity");
  
  });
  /*var $carousel = $('div.ProductList').flickity({
    on: {
      ready: function() {
        console.log('Flickity is ready');
      },
      change: function( index ) {
        console.log( 'Slide changed to' + index );
      }
    }
  });
  console.log($carousel.length);*/
  let piImg = $("img.ProductItem__Image");
  //console.log("ProductItem__Image count " + piImg.length);

  piImg.each(function () {
    if (this.complete) {
      //console.log("Image complete: " + this.alt);        
      // callback here
      onImageLoad(null, this);
    }
  });

  piImg.load(onImageLoad);
});


function onImageLoad(e, obj) {
  //console.log("ProductItem__LabelLists all loaded");
  //console.log("ProductItem img: " + this.alt);
  //console.log(this.parentNode);
  if (obj === undefined) {
    obj = this;
    //console.log("OIL obj undef");
  } else {
    //console.log("OIL obj defined");
  }
  
  
  let piWrapper = obj.parentNode.parentNode.parentNode;
  let labList = $(piWrapper).find("div.ProductItem__LabelList");//piWrapper.children[1];
  //console.log(++counter + " " + this.clientWidth + " " +
  //          this.complte + " " + labList.complete);
  let swatchList = $(labList).find("div.ProductItem__SizeSwatchList");
  //console.log(swatchList.length);
  
  if (swatchList.length == 0)
    return;
  
  
  $(labList).css("width", obj.width - 20);
  let height = obj.height - swatchList[0].clientHeight -
      2 * $(labList).position().top - 4;
  //console.log(height);
  $(swatchList).css("top", height + "px");  
  //$(labList).css("position", "absolute");
  //$(labList).css("height", this.height - 20);
  let lastHeight = swatchList[0].clientHeight;
  let test = 33;
  let img = obj;
  $(swatchList).mouseover(function() {
    onSwatchHover(swatchList[0], height, lastHeight);
  });
  $(swatchList).mouseleave(function() {
    onSwatchLeave(swatchList[0], height, lastHeight);
  });
  
  $(obj).mouseover(function () {
    onProdImgEnter(this, swatchList[0]);
  });
  
  $(obj).mouseleave(function (e) {
    onProdImgExit(this, swatchList[0], e.toElement);
  });
  
  //let prodItemLabList = $("div.ProductItem__LabelList");

  /*prodItemLabList.each(function () {
    //$(this).css("height", prodItemImg[0].height - 10);
    $(this).css("width", img.width - 20);
  	//console.log(this.style.width);
  });*/
  
}

function onSwatchHover(obj, height, lastHeight) {
  //console.log(obj);
  if (obj === undefined)
    obj = this;
  
  //if (!$(obj).data("fheight"))
  //  $(obj).data("fheight", $(obj).clientHeight);
  $(obj).css("width", obj.parentNode.clientWidth);
  let padY = 1.625 * 2;
  let padX = 8.125 * 2;
  let fontSz = 15;
  //$(obj).addClass("ProductItem__SizeSwatchListOn");
  $(obj).css("top", height -
             obj.clientHeight
             //$(obj).data("fheight") 
             + lastHeight);
}

function onSwatchLeave(obj, height, firstHeight) {
  //console.log("Swatch Leave");
  if (obj === undefined) {
    obj = this;
	console.log("Swatch obj invalidated");    
  }
  //if ($(obj).attr("hovered") === undefined) return;
  $(obj).css("width", "auto"); 
  $(obj).attr("hovered", undefined);

  let padY = 1.625 * 2;
  let padX = 8.125 * 2;
  let fontSz = 15;
  //$(obj).removeClass("ProductItem__SizeSwatchListOn");
  $(obj).css("top", height - 0*firstHeight);
}

function onProdImgEnter(obj, sizeSwatch) {
  $(sizeSwatch).css("opacity", 1.0);
}

function onProdImgExit(obj, sizeSwatch, target) {
  //console.log("ImgExit: " + sizeSwatch);
  //console.log(target);
  if (target === null || target.className != "ProductItem__SizeSwatchList")
  	$(sizeSwatch).css("opacity", 0.00);
}


  
setTimeout(function() {

}, 0);
// Utility function I wrote that appears useless
function getElemNodeTree(nodes) {
  let res = {
    children : [],
  };
  
  if (nodes.children) {
    res.className = nodes.className;
    res.localName = nodes.localName;
    for (let elem of nodes.children) {
      res.children.push(getElemNodeTree(elem));
    }
    return res;
  }
  
  for (let elem of nodes) {
    let newElem = {
      children : [],
      className : elem.className,
      localName : elem.localName
    }
    console.log("Node: " + elem);
    res.children.push(newElem);
   	newElem.children.push(getElemNodeTree(elem));
  }
  return res;
}

let carouselIntercept = 0;
var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    //console.log(mutation.addedNodes)
    let carousel = $("div.Carousel");
    
    if (carousel.length > 0) {
	  carouselIntercept++;
      //console.log("Intercept " + carouselIntercept);
    }
    
    if (carousel.length > 0 && carouselIntercept >= 7) {
      //console.log(carousel[0]);
      let piImg = carousel.find("img.ProductItem__Image");
      //console.log(carousel.length + " " + piImg.length);
      piImg.load(onImageLoad);
    }
    
    // Miscellaneous interceptions I want to do, TODO
    let ytpTitleText = $("div.ytp-chrome-top");
    //console.log(ytpTitleText.length);
    
    let imageHero = $("iframe.ImageHero__VideoHolder");
    //console.log("VideoHolder: " + imageHero.length);
    
    if (imageHero.length > 0) {
      //console.log(imageHero); 
    }
    //console.log("DOM update observed");
  });
});

var config = {
    attributes: true,
    childList: true,
    characterData: true
};

observer.observe(document.body, config);

if (typeof product != "undefined") { // Emitted on product form page
	//console.log(product);
} else if (typeof products != "undefined") {
 	//console.log(products); 
}

let sizeSwatches = $("label.SizeSwatch");
//console.log(sizeSwatches.length + " size swatches");
//console.log(sizeSwatches.prev());

//console.log(prodSels);

function updateCartOld() {
  let miniCartItemWrapper = $(miniCartItWrapper);
  Shopify.getCart(function(cart) {
    var currencySwitcher, currencyValue, i, image, item, len, price, ref;
    miniCartItemWrapper.empty();
    $("[data-cart-count]").html("<span class=\"cart-count-text\">{{ 'layout.header.cart' | t | escape }}</span>\n(<span class=\"cart-count-number\">" + cart.item_count + "</span>)");
    ref = cart.items;
    for (i = 0, len = ref.length; i < len; i++) {
      item = ref[i];
      price = Shopify.formatMoney(item.price, Theme.moneyFormat);
      image = item.image != null ? item.image : "{{ 'no-image.svg' | asset_url }}";
      miniCartItemWrapper.append(
        "<article\n" +
         "class=\"mini-cart-item\"\n" + 
         "data-variant=\"" + item.variant_id + "\"\n" + 
         "data-url=\"" + item.url + "\"\n" + 
         "data-title=\"" + item.title + "\"\n" +
        ">\n" +
          "<figure class=\"mini-cart-item-image\">\n" +
            "<a href=\"" + item.url + "\">\n" +
              "<img alt=\"" + item.title + "\" src=\"" + image + "\">\n" + 
            "</a>\n" + 
          "</figure>\n" + 
          "<div class=\"mini-cart-item-details\">\n" +
            "<p class=\"mini-cart-item-quantity\">\n" + 
              "Qty: <span>" + item.quantity + "</span>\n" +
        	"</p>\n" +
        	"<p class=\"mini-cart-item-title\">\n" + 
        	  "<a href=\"" + item.url + "\">" + item.title + "</a>\n" + 
        	"</p>\n"+
        	"<p class=\"mini-cart-item-price\">\n" +
        	  "<span class=\"money\">" + price + "</span>\n" + 
        	"</p>\n" +
          "</div>\n" +
        "</article>");
    }
    currencySwitcher = $(".currency-switcher select");
    currencyValue = currencySwitcher.val();

    // show mini cart
    console.log('updateCart - ' + cart.total_price);
    let totalPrice = Shopify.formatMoney(cart.total_price, Theme.moneyFormat);
    if( cart.total_price == 0 ){
      $('.show-mini-cart').hide();
    }else{
      $('.show-mini-cart').show();
    }
    $('.devst_subtotal').html('Total: ' + totalPrice); 

    return currencySwitcher.val(Theme.currency).trigger("reset-currency").val(currencyValue).trigger("reset-currency");
  });
  
}

function addToCartImpl() {
  let prodSels = [];
  sizeSwatches.prev().each(function () {
    if (this.checked) {
      let content = $(this).next().html().trim();
      //console.log("Checked: " + content);
      prodSels.push(content);
    }
  });
  
  let variant;
  //console.log(product);
  
  for (let obj of product.variants) {
	if (obj.option1.localeCompare(prodSels[0]) === 0 &&
        obj.option2.localeCompare(prodSels[1]) === 0) {
      //console.log("Found var: ");
      console.log(obj);
      //console.log();
      
      variant = obj;
      break;
    }
  }
  
  let url = window.location.pathname + window.location.search;
  let psnis = $("a.Product__SlideshowNavImage");
  let psni = psnis.filter(".is-selected");
  console.log(psni);
  let price = Shopify.formatMoney(variant.price, Theme.moneyFormat);
  
  $(miniCartItWrapper).prepend(
    "<article class='mini-cart-item'" + "data-variant='" + variant.id + 
    "' data-url='" + url +
    "' data-title='" + variant.name +
    "'>" + 
	  "<figure class='mini-cart-item-image'>" +
        "<a href='" + url + "'>" +
          "<img alt='" + variant.featured_media.alt + "' src='" +
            // This was a bust, perhaps the Newsletter funnel has the same media issue
    		//variant.featured_media.preview_image.src 
    		psni[0].children[0].src +
          "' style='width:75px;height:100px'/>" +
    
    	"</a>" +
      "</figure>" +
      "<div class=\"mini-cart-item-details\">" +
        "<p class=\"mini-cart-item-quantity\">" + 
          "Qty: <span>" + 1 + "</span>\n" +
		"</p>" +
    	"<p class=\"mini-cart-item-title\">" + 
       	  "<a href=\"" + url + "\">" + variant.name + "</a>" + 
        "</p>\n"+
        "<p class=\"mini-cart-item-price\">" +
       	  "<span class=\"money\">" + price + "</span>" + 
       	"</p>" +
	  "</div>" +
      "<a class='devst_remove_item' style='cursor:pointer;'>REMOVE</a>" +
    "</article>");
  //console.log(miniCartItWrapper.children[0]);
  $(miniCartItWrapper.children[0]).find('.devst_remove_item').click(onRemoveClicked);
  //updateCartOld();
}

if (typeof product != "undefined") {
	//console.log(product);
}


//console.log("SelectedSwatches: " + sizeSwatches.prev().find(":checked").length);

/*sizeSwatches.each(function () {
  $(this).attr("title", "Quantity coming soon");
});*/

sizeSwatches.click(function () {
  scrollAnimating = true;
  //selectScrollTrack = true;
  //setTimeout(function () { selectScrollTrack = false; }, 370);
    
  
  let color = "";
  for (let variant of product.variants) {
    //console.log("'" + variant.option1 + "' '" + this.innerHTML.trim() + "'");
    if (variant.option1.localeCompare(this.innerHTML.trim()) === 0) {
      //console.log("Found equivalent option1: " + this.innerHTML); 
      color = variant.option1;
    
      sizeSwatches.each(function () {
        if (this.innerHTML.trim().localeCompare(variant.option2) == 0) {
          let input = $(this).prev();
          if (variant.inventory_quantity > 0) {
           	input.prop("disabled", false);
            $(this).css("color", ""); 
          } else {
            //input.prop("disabled", true);
			$(this).css("color", "lightgray"); 
          }
          //console.log(this); 
        }
      })
    }
    
  }
  
  let pw = $("div.Product__Wrapper");
  setTimeout(function () {
    //pw.css("min-height", "0px");
  }, 100);
});

// Credits to https://stackoverflow.com/questions/19491336/how-to-get-url-parameter-using-jquery-or-plain-javascript
var getUrlParameter = function getUrlParameter(sParam) {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName;

    for (let i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

function getUrlParameters() {
  let sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParToks;
  
  let res = [];

  for (let i = 0; i < sURLVariables.length; i++) {
    sParToks = sURLVariables[i].split('=');

    res.push({ parm: sParToks[0], 
                val: decodeURIComponent(sParToks[1]) });
  }
  return res;
};

// Newsletter
let customer_posted = getUrlParameter("customer_posted");
if (customer_posted) {
  $("html, body").animate({ scrollTop: $(document).height() }, 2000);
}



function onColorSwatchClicked(e) {
  if (e == null)
    e = this;
    
    //console.log("ColorSwatch interaction");
  let piColorSwatch = e.parentNode;
  let colorSwatchList = piColorSwatch.parentNode;
  let piInfo = colorSwatchList.parentNode;
  let piWrapper = piInfo.parentNode;
  let prodItem = piWrapper.parentNode;
  let gridCell = prodItem.parentNode;
  let prodList = gridCell.parentNode;
  
  let link = piWrapper.children[0];
  let href = $(link).attr("href");
  let varidx = href.indexOf("variant=");
  let variant = href.substring(varidx + 8);
  let image = variant.indexOf("#Image");
  
  if (image > 0) {
    variant = variant.substring(0, image);
  }
  
  let index = -1;
  let variantNum = parseInt(variant);
  
  for (let i in products) {
	let prod = products[i];
    for (let v in prod.variants) {
      if (prod.variants[v].id == variantNum) {
        //console.log(prod.variants[v].id + " " + variantNum);
      	index = i;
      }
    }
  }
  
  //console.log(href);
  //console.log(variant);
  //console.log(piWrapper);
  
  if (index == -1) {
    for (let i in prodList.children) {
      if ($(prodList.children[i])[0] === $(gridCell)[0]) {
        index = i;
        break;
      }
    }
    index = (index - 1) / 2;
  }
  
  
  //console.log("ColorSwatch product index " + index);
  //console.log("UUID: " + this.title);
  
  //console.log("Expected title: " + products[index].title);
  
  let labList = $(piWrapper).find("div.ProductItem__LabelList");
  let swatchList = $(labList).find("div.ProductItem__SizeSwatchList");
  
  //$(labList).append("<div class=\"ProductItem__SizeSwatchList\">SIZES</div>");
  let height = e.height - swatchList[0].clientHeight -
      2 * $(labList).position().top - 4;
  let lastHeight = swatchList[0].clientHeight;
  //console.log(swatchList[0]);
  if (swatchList.length == 0) {
    console.log("swatchList 0"); 
  }
  
  $(swatchList).mouseover(function() {
    onSwatchHover(swatchList[0], height, lastHeight);
  });
  $(swatchList).mouseleave(function() {
    onSwatchLeave(swatchList[0], height, lastHeight);
  });
  
  
    
  let title = e.title.trim();
  let tid;
  function deferred() {
	let img = $(piWrapper).find("img.ProductItem__Image");
 
  	//console.log(img);
    $(img).mouseover(function () {
      //console.log("over");
      onProdImgEnter(this, swatchList[0]);
  	});

    $(img).mouseleave(function (e) {
      onProdImgExit(this, swatchList[0], e.toElement);
    });
  
    //console.log("Image behavior");
    
    $(swatchList).empty();
    $(swatchList).html("SIZES<br>");
    
    
    for (let variant of products[index].variants) {
      //console.log("'" + title + "' '" + variant.option1 + "'");
      if (title.startsWith(variant.option1) == 1) {
		$(swatchList).append("<button class=\"ProductItem__SizeSwatch\"\n" +
                             (variant.inventory_quantity == 0 ? "style=\"color:lightgray;\"":"") +
                             ">" + variant.option2 + "</div>");        
      }
    }
    
    //clearInterval(tid);
  }
  
  tid = setTimeout(deferred, 120);
  
}

let colorSwatches = $("label.ColorSwatch");
//console.log("ColorSwatches: " + colorSwatches.length);

let collSideLabs = $("label.Text--subdued");
//console.log("collSideLabs: " + collSideLabs.length);

let collSideLabClick;

collSideLabs.click(collSideLabClick = function () {
  console.log("Side clicked");
  setTimeout(function () {
  	colorSwatches = $("label.ColorSwatch");
    console.log("colorSwatches: " + colorSwatches.length);
  	colorSwatches.click(function () {
    	let _this = this;
    	onColorSwatchClicked(_this); 
  	});
    
	collSideLabs = $("label.Text--subdued");
	console.log("collSideLabs: " + collSideLabs.length);
	collSideLabs.click(collSideLabClick);
    
  }, 999);
  
});

colorSwatches.click(function () {
  let _this = this;
  setTimeout(function () {
    onColorSwatchClicked(_this); 
  }, 50);
});

// Time to hack code we don't own - IAgree hacks
let headerIcon = $("a.Header__Icon");
//console.log("Header__Icon: " + headerIcon.length);

function onSideCartReady() {
  let wptcTerms = $("#wptc-terms");
  if (wptcTerms.length < 1) {
    console.log("couldn't find terms"); 
  }
  //console.log("wptc-terms: " + wptcTerms.length);
  wptcTerms.prop("checked", true);
  let iagree = $("#iagree");
  if (iagree.length < 1) {
    console.log("couldn't simulate agreement");
  }
  //console.log("div:#iagree: " + iagree.length);
  iagree.hide();

}

headerIcon.click(onSideCartReady);
$(horizontalItem).click(onSideCartReady);

//setTimeout(onSideCartReady, 333);

// Collection Filter Drawer

let cti = $("button.CollectionToolbar__Item");

function onEachLL() {
  //console.log("linkList: ");
  //console.log(this);
  //console.log(this.children[1]);
  let child = this.children[1];
  $(child).click(function () {
    //console.log("Clicked!");    
    setTimeout(function () {
      //console.log(getUrlParameters());
	  //console.log(child);
      //console.log(linkList[0]);

      onFormLinks();
    }, 1400);
  });
}

function onFormLinks() {
  let cff = $("form.collection-filters-form");
  //console.log("cff: " + cff.length);
  
  let linkList = cff.find("li.Linklist__Item");
  //console.log("llItem: " + linkList.length);
  
  linkList.each(onEachLL);
}

cti.click(function () {
  //console.log("CTI: " + $(cti).html().trim());
  let cff = $("form.collection-filters-form");
  //console.log("cff: " + cff.length);
  
  let preParms = getUrlParameters();
  
  let prepend = "<div class=\"Holder\">";
  for (let parm of preParms) {
    if (parm.parm.indexOf("option") > -1) {
      prepend += parm.val + " "; 
    }
  }
  prepend += "</div>";
  //cff.prepend(prepend);
  
  //cff.prepend("Bye world");
  if ($(cti).html().trim().startsWith("Filter")) {
	//let linkList = $("li.Linklist__Item");
	//console.log("llItem: " + linkList.length);
    
    
    //onFormLinks();
    /*inkList.click(function() {

    });*/
  }
});

let cff = $("form.collection-filters-form");
//console.log("CFF stateless: " + cff.length);

cff.change(function (e) {
  
  e.preventDefault();
  //console.log("Form change");
  
  setTimeout(function () {
  	let piImg = $("img.ProductItem__Image");
  	//console.log("ProductItem__Image: " + piImg.length);
  	piImg.each(onImageLoad);
  }, 2000);
  //cff.submit(onSubmit);
});

/*cff.reset(function (e) {
  console.log("Form reset");
});*/

function onSubmit(e) {
  //console.log("Form submit");
    e.preventDefault(); // prevent actual form submit
    var form = $(this);
    var url = form.attr('action'); //get submit url [replace url here if desired]
    $.ajax({
         type: "POST",
         url: url,
         data: form.serialize(), // serializes form input
         success: function(data){
           //console.log("Form success: " + data);
         }
    });
}

cff.submit(onSubmit);

/* Failed routing
$(window).on("hashchange", function () {
	console.log("Window changed");  
});

window.addEventListener('popstate', () => {
    console.log("Window popstate");
})*/

// Keyboard product image navigation, later reused for navigation arrows
let selectScrollTrack = false;
function selectNextProdImg() {
  //console.log("Next image");
  let psnis;
  //console.log("last: " + lastWidth + " inclusive: " + window.innerWidth);
  if (window.innerWidth < 1008) {
    //console.log("Dot matrix");
    psnis = $("button.dot");
    //console.log("Found " + psnis.length);
  } else
  	psnis = $("a.Product__SlideshowNavImage");
  //let idx = Math.floor(Math.random() * 3);
    let psni = psnis.filter(".is-selected");
	let idx = 0;
    for (let i in psnis) {
      if (!$.isNumeric(i)) {
        continue; 
      }
      //console.log("index? '" + i + "' " + typeof(i));
      if (psnis[parseInt(i)] === psni[0]) {
         idx = parseInt(i);
         //console.log("idx = " + idx);
         break;
      }
    }
    idx = (idx + 1) % psnis.length;
    
  if (window.innerWidth < 1008) {
    psni.removeClass("is-selected");
    psnis[idx].click();
  } else {
    psnis[idx].click();
    psni.removeClass("is-selected");
  }
    lastNavIdx = idx;
    $(psnis[idx]).addClass("is-selected");
  
  
  	let psns = psnis[0].parentNode;
    let mb = parseInt($(psnis[0]).css("margin-bottom"));
    let unitHeight = mb + psnis[0].clientHeight;
    let top = $(psns).scrollTop();
    let realIdxScroll = top / unitHeight;
    let destPageID = Math.floor(idx / 4);
    let currPageID = Math.floor(realIdxScroll / 4);

    gotoNaviPage(destPageID);
  	
    /*if (psnu.length > 0) {
      if (idx == 0) {
        let pages = psnis.length / 4;
        onNaviPrev(null, pages); 
      } else if (idx % 4 == 0) {
      	onNaviNext();        
      }
    }*/
  
    //console.log("idx: " + idx);
    //console.log(psnis[idx]);
    
    //console.log("Right");
}

function selectPrevProdImg() {
    let psnis;
  if (window.innerWidth < 1008) {
      psnis = $("button.dot");
    } else
      psnis = $("a.Product__SlideshowNavImage");
    let psni = psnis.filter(".is-selected");
	let idx = 0;
    for (let i in psnis) {
      if (!$.isNumeric(i)) continue; 
      
      if (psnis[parseInt(i)] === psni[0]) {
         idx = parseInt(i);
         break;
      }
    }
  
    idx = (idx - 1);
    if (idx < 0) idx = psnis.length - 1;
  
  	psnis[idx].click();
    psni.removeClass("is-selected");
  	lastNavIdx = idx;
    $(psnis[idx]).addClass("is-selected");
  
  	let psns = psnis[0].parentNode;
    let mb = parseInt($(psnis[0]).css("margin-bottom"));
    let unitHeight = mb + psnis[0].clientHeight;
    let top = Math.ceil($(psns).scrollTop());
    let realIdxScroll = top / unitHeight;
    let destPageID = Math.floor(idx / 4);
    let currPageID = Math.floor(realIdxScroll / 4);

    gotoNaviPage(destPageID);
    
}

let flickPort = $("div.flickity-viewport");
//console.log("flickity-viewport count " + flickPort.length);
//console.log("flickity-viewport child count (A) " + flickPort[0].children.length);

  let url2 = window.location.pathname + window.location.search;

//console.log(window.location.pathname);
let path = window.location.pathname;

// For Horizontal Layout of Scroll Navigation Images
function onFlickReady() {
  flickPort = $("div.flickity-viewport");
  if (flickPort.length > 0) {
    console.log("FP: " + flickPort[0].children.length + " VP: " + flickPort.length);
    for (let i = 0; i < flickPort.length; i++) {
      console.log("FPP[" + i + "] " + flickPort[i].parentNode.className); 
    }
  }
if (flickPort.length > 0 && path.startsWith("/products") &&
   flickPort[0].children.length == 1) {
  console.log("Attaching arrows");
  $(flickPort[0]).append(
    "<div style='position:absolute; width:40px; stroke:black; left:30px; top:45%; display:inline-block;z-index:9000;'>" +
      "<svg viewBox='0 0 100 100'>" +
        "<path d='M 25,50 L 60,100 L 60,100 L 25,50  L 60,0 L 60,0 Z' class='arrow'></path>" +
      "</svg>" +
    "</div>");

  $(flickPort[0]).append(
    "<div style='position:absolute; width:40px; stroke:black; right:30px; top:45%; display:inline-block;z-index:9000;'>" +
      "<svg viewBox='0 0 100 100'>" +
        "<path d='M 25,50 L 60,100 L 60,100 L 25,50  L 60,0 L 60,0 Z' class='arrow' transform='translate(100, 100) rotate(180) '></path>" +
      "</svg>" +
    "</div>");
  //console.log("flickity-viewport child count (P) " + flickPort[0].children.length);

  $(flickPort[0].children[1]).click(selectPrevProdImg);
  $(flickPort[0].children[2]).click(selectNextProdImg);

}
}
onFlickReady();

document.addEventListener('keydown', onKeyDown);


function onKeyDown(e) {
  //console.log(` ${e.code}`);
  
  if (e.code.localeCompare("ArrowRight") === 0) {
	selectNextProdImg();
  } else if (e.code.localeCompare("ArrowLeft") === 0) {
	selectPrevProdImg();
  }
}

// Navigation arrows and clipping implementation
let psnis = $("a.Product__SlideshowNavImage");
//console.log("Product__SlideshowNaviImage count: " + psnis.length);

let psnu = $("svg.Product__SlideshowNavUp");
let onNaviPrev;
let onNaviNext;
let gotoNaviPage;
let lastNavIdx = 0;
let ps = $("div.Product__Slideshow");

function onNaviReady() {
if (psnis.length > 4) {
  let mb = parseInt($(psnis[0]).css("margin-bottom"));
  let unitHeight = mb + psnis[0].clientHeight;
  //console.log("MB: " + mb + " height: " + psnis[0].clientHeight);
  //console.log("original UH: " + unitHeight);
  let psns = psnis[0].parentNode; // div.Product__SlideshowNavScroller container of images
  $(psns).css("overflow", "hidden");
  $(psns).css("height", (4 * (unitHeight + -0))); // only for last page scroll looking correct
  let psn = psnis[0].parentNode.parentNode; // div.Product__SlideshowNav
  // we hardcode 44 for 2x11.5 of nav buttons 2x10 for hardcoded padding
  $(psn).css("height", (4 * unitHeight + 21 + 20) + "px");
  let prev = $(psn.children[0]);
  let next = $(psn.children[psn.children.length - 1]);
  //prev.click(selectPrevProdImg);
  
  onNaviPrev = function (e, pages) {
    //console.log("onNaviPrev");
    selectScrollTrack = true;
  	setTimeout(function () { selectScrollTrack = false; }, 400);
    if (typeof(pages) === "undefined") pages = 1;

    let top = $(psns).scrollTop();
    
    if (false && top / (4 * unitHeight) != Math.floor(top / 4 * unitHeight) && pages === 1) {
      top -= top % (unitHeight * 4);
      //top += 4 * unitHeight;
    } else {
      //console.log("psnlen?: " + psns.children.length);

      if (top + 4 * unitHeight >= psns.children.length * unitHeight && pages == 1) {
        //console.log("top: " + top + " top+4u: " + (top + 4 * unitHeight) + " psnlen: " +
        //            (psns.children.length * unitHeight));
        
        top -= top % (unitHeight * 4);
        //console.log("Prev module edge case");
      } else {
        top -= top % (unitHeight * 4);
        top -= 4 * unitHeight * pages;
      }
    }

    if (top <= 0) {
      top = 0;
      prev.css("color", "#aaa");
	  prev.css("cursor", "default");
      
    }
    
    next.css("color", "#222");
	next.css("cursor", "pointer");
    
    
    $(psns).animate({scrollTop: top}, 400);
    let idx = top / unitHeight;
    lastPage = Math.floor(idx / 4);
    //$(psns).scrollTop(top); 
  }
  
  let maxPage = Math.ceil(psns.children.length / 4);
  
  prev.click(function () {
    let psnis = $("a.Product__SlideshowNavImage");
    let psns = psnis[0].parentNode;

    let mb = parseInt($(psnis[0]).css("margin-bottom"));
    let unitHeight = mb + psnis[0].clientHeight;
    let top = Math.ceil($(psns).scrollTop());
    let realIdxScroll = top / unitHeight;
    let currPageID = Math.floor(realIdxScroll / 4);

    var maxScrollTop = psns.scrollHeight - $(psns).outerHeight();
    let scroll = Math.ceil($(psns).scrollTop());
    
    if (scroll == maxScrollTop) {
      currPageID = maxPage - 1;
    }
    
    console.log("ridxs: " + realIdxScroll + " cpid: " + currPageID); 
    console.log("mst: " + maxScrollTop + " s: " + scroll);
    
    currPageID--;
    if (currPageID >= 0)
    	gotoNaviPage(currPageID);
  });
  

  onNaviNext = function (e, pages) {
    //console.log("onNaviNext");
    selectScrollTrack = true;
  	setTimeout(function () { selectScrollTrack = false; }, 400);
    if (typeof(pages) === "undefined") pages = 1;
    let top = $(psns).scrollTop();

    if (top / unitHeight + 4 < psns.children.length) {
      top += 4 * unitHeight * pages;
	  top -= top % (4 * unitHeight);

      //console.log("unitHeight: " + unitHeight + " top: " + top);
      
      $(psns).animate({scrollTop: top}, 400);
      //$(psns).scrollTop(top); 
      prev.css("color", "#222");
	  prev.css("cursor", "pointer");
      
      if (top / unitHeight + 4 >= psns.children.length) {
        next.css("color", "#aaa");
	    next.css("cursor", "default");
      }
    }
    
    let idx = top / unitHeight;
    lastPage = Math.floor(idx / 4);
  }
  
  next.click(function () {
    let psnis = $("a.Product__SlideshowNavImage");
    let psns = psnis[0].parentNode;

    let mb = parseInt($(psnis[0]).css("margin-bottom"));
    let unitHeight = mb + psnis[0].clientHeight;
    let top = Math.ceil($(psns).scrollTop());
    let realIdxScroll = top / unitHeight;
    let currPageID = Math.floor(realIdxScroll / 4);

    
    currPageID++;
    gotoNaviPage(currPageID);
  });
  
  
  gotoNaviPage = function(id) {
    //console.log("gotoNaviPage with " + (id * unitHeight * 4));
    $(psns).stop();
    $(psns).animate({scrollTop: Math.ceil(id * unitHeight * 4)}, 400);
    
    if (id != maxPage - 1) {
      next.css("color", "#222");
	  next.css("cursor", "pointer");
    } else {
      next.css("color", "#aaa");
	  next.css("cursor", "default");
    }
    
    if (id > 0) {
      prev.css("color", "#222");
	  prev.css("cursor", "pointer"); 
    } else {
      prev.css("color", "#aaa");
	  prev.css("cursor", "default");
    }
  }
  
  $(psns.children[psns.children.length - 1]).css("margin-bottom", mb + "px");
  
  prev.css("color", "#aaa");
  next.css("cursor", "pointer");
  
  for (let i = 1; i < psnis.length; i++) {
    $(psnis[i]).css("height", (unitHeight - mb + 0) + "px");
  }
  
  $(ps[0].children[psnis.length - 1]).css("margin-bottom", "100px");

}
}
onNaviReady();

let lastWidth = window.innerWidth;//$(window).width();

$(window).resize(function () {
  let width = window.innerWidth;//$(this).width();
  if (width >= 1140 && lastWidth < 1140) {
    onNaviReady();
    //console.log("Recalculating navi for width: " + width);
  }
  if (width < 1008 && lastWidth >= 1008) {
    setTimeout(function () {
      onFlickReady();    
    }, 575);
    //console.log("Recalculating flick for width: " + width);
  }
  lastWidth = width;
});

$.fn.preBind = function(type, data, fn) {
  this.bind(type, data, fn);

  var newBindings = [];

  if (typeof(this.data(this, 'events')[type]) != 'undefined') {
    var currentBindings = this.data(this, 'events')[type];
    //console.log(currentBindings);
    var currentBindingsLastIndex = currentBindings.length - 1;


    newBindings.push(currentBindings[currentBindingsLastIndex]);

    $.each(currentBindings, function (index) {
      if (index < currentBindingsLastIndex)
        newBindings.push(this);
    });
  }

  this.data(this, 'events')[type] = newBindings;

  
  return this;
};


function onNaviClicked() {
    //console.log("psnis cilck invoked");
    //console.log(psnis);
    selectScrollTrack = true;
    setTimeout(function () { selectScrollTrack = false; }, 400);
    
    //console.log(this.className);
  	let psnd = $("a.Product__SlideshowNavDot");
  	let _psnis = this.className.startsWith("Product__SlideshowNavDot") ? psnd : psnis;
  
	for (let i in _psnis) {
      if (!$.isNumeric(i)) continue; 
      
      if (_psnis[parseInt(i)] === this) {
         idx = parseInt(i);
         //console.log("Clickied " + idx);
         //break;
        $(_psnis[idx]).addClass("is-selected");
        
        let psns = _psnis[0].parentNode;
        let mb = parseInt($(_psnis[0]).css("margin-bottom"));
        let unitHeight = mb + _psnis[0].clientHeight;
        let top = $(psns).scrollTop();
        let realIdxScroll = top / unitHeight;
        let destPageID = Math.floor(idx / 4);
        let currPageID = Math.floor(realIdxScroll / 4);

        gotoNaviPage(destPageID);
        lastPage = destPageID;
      } else {
       $(_psnis[parseInt(i)]).removeClass("is-selected"); 
      }
    }
}

psnis.preBind('click', onNaviClicked);
$("a.Product__SlideshowNavDot").click(onNaviClicked);

let pw = $("div.Product__Wrapper");
let psnd = $("div.Product__SlideshowNav--dots");

let lastPage = 0;
let modulateScroll;
setTimeout(function () {
ps.scroll(function () {
  if (selectScrollTrack) {
    return;
  }
  
  modulateScroll = function(obj) {
    
    let psnis = $("a.Product__SlideshowNavImage");
    let psni = psnis.filter(".is-selected");
    let psns = psnis[0].parentNode;

    let idx = 0;
    for (let i in psnis) { if (!$.isNumeric(i)) continue; 
      if (psnis[parseInt(i)] === psni[0]) { idx = parseInt(i); break; }
    }

    let mb = parseInt($(psnis[0]).css("margin-bottom"));
    let unitHeight = mb + psnis[0].clientHeight;
    //console.log("uh now: " + unitHeight);
    let top = Math.ceil($(psns).scrollTop());
    let realIdxScroll = top / unitHeight;
    let destPageID = Math.floor(idx / 4);
    let currPageID = Math.floor(realIdxScroll / 4);

  	//console.log("(" + idx + ")" + " psns-top: " + top + " C-" + currPageID + " D-" + destPageID);
  
    gotoNaviPage(destPageID); 

    if (destPageID != currPageID) {
    }
  
    //console.log("u: " + unitHeight + "t/u: " + (top / unitHeight) + " fl: " + Math.floor(top / unitHeight));
    if (top / unitHeight == Math.floor(top / unitHeight) && !selectScrollTrack && false)
    for (let i = 0; i < obj.children.length; i++) {
      let media = obj.children[i];
      if (obj.scrollTop >= media.offsetTop &&
          obj.scrollTop < media.offsetTop + media.clientHeight) {

        for (let j = 0; j < obj.children.length; j++) {
          $(psnis[j]).removeClass("is-selected");
        }

        $(psnis[i]).addClass("is-selected");

        break;
      }
    }
  };
  modulateScroll(this);
  
  return;
});
}, 100);

// Some App broke the searchbar routes, time for somebody to do something about it
function onNeedsSearch() {
  let ssb = $("div.Search__SearchBar");
  //console.log("SSB: " + ssb.length);
  let route = $(ssb[0].children[0]).attr("action");
  //console.log("route: " + route);
  if (route.startsWith("/a")) {
    $(ssb[0].children[0]).attr("action", route.substring(2));
  }
}
$(hiSearch).click(onNeedsSearch);

// Research for converting the Product__Form from indefinitely sized product--fill intersection Prestige implementation
// to proprietary viewport based implementation
setTimeout(function () {
	let pw = $("div.Product__Wrapper");
  	let img = pw.find("img.Image--fadeIn");
}, 100);

// ===================
// Post launch goodies
// ===================

setTimeout(function () {
  return;
  console.log("Autoplaying videos");

    
  let playerPoster = $("div.plyr__poster");
  
  if (playerPoster.length > 0) {
     playerPoster.click();
  } else {
    console.log("No videos to play"); 
  } 
}
, 950);  

